module.exports = __webpack_public_path__ + "img/02.e5c5c1ea.svg";